import { PatientActions } from 'src/redux/actions/constant';

const { RESET_EDIT_PATIENT, SUCCESS_EDIT_PATIENT, FAILURE_EDIT_PATIENT, LOADING_EDIT_PATIENT } =
  PatientActions;

const intitialstate: object = {
  isPatientEdited: false,
  response: null,
  loading: false,
};

export const editPatientReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_EDIT_PATIENT: {
      return {
        ...state,
        isPatientEdited: true,
        response: action.payload,
        loading: false,
      };
    }

    case FAILURE_EDIT_PATIENT:
      return {
        ...state,
        isPatientEdited: false,
        response: action.payload,
        loading: false,
      };

    case LOADING_EDIT_PATIENT:
      return {
        ...state,
        loading: true,
      };

    case RESET_EDIT_PATIENT:
      return intitialstate;

    default:
      return state;
  }
};
